const lang_en = {
    // Navigations
    "home": "Home",
    "map": "Map",
    "about": "About",
    "contact": "Contact",

    // Hero (Home)
    "title_1" : "Geographical Information System",
    "title_2" : "and many others.",
    "subtitle" : "Dedicated from agrabinta people, by agrabinta people, for agrabinta people.",
    "go_to_map": "Go to map",

    // Map

    // About

    // Contact
}

export default lang_en;